import { render, staticRenderFns } from "./GamePlayPage.vue?vue&type=template&id=1193320b&scoped=true"
import script from "./GamePlayPage.vue?vue&type=script&lang=js"
export * from "./GamePlayPage.vue?vue&type=script&lang=js"
import style0 from "./GamePlayPage.vue?vue&type=style&index=0&id=1193320b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193320b",
  null
  
)

export default component.exports